export default () => {

	const stylesWrappers = document.querySelectorAll('.js-styles-wrapper');
	if (!stylesWrappers.length) return;

	stylesWrappers.forEach(wrapper => {

		const cards = wrapper.querySelectorAll('.js-style-card');
		const hoverCards = wrapper.querySelectorAll('.js-style-card-hover');

		cards.forEach(card => {
			card.addEventListener('mouseenter', () => {
				wrapper.classList.add('hover');
				card.classList.add('hover');
			});

			card.addEventListener('mouseleave', () => {
				wrapper.classList.remove('hover');
				card.classList.remove('hover');
			});

			card.addEventListener('click', () => {
				if (!card.matches('.clicked')) {
					wrapper.classList.add('clicked');
					card.classList.add('clicked');
				}
				else {
					card.classList.remove('clicked');
					if (!wrapper.querySelector('.js-style-card.clicked')) {
						wrapper.classList.remove('clicked');
					}
				}
			})
		});

		hoverCards.forEach(card => {
			card.addEventListener('mouseenter', () => {
				wrapper.classList.add('hover');
				card.classList.add('hover');
			});

			card.addEventListener('mouseleave', () => {
				wrapper.classList.remove('hover');
				card.classList.remove('hover');
			});
		});

	});

}